import ReactDOM from 'react-dom';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { Col} from 'react-bootstrap';
import Utils from './Utils';
import { getLastMessages, getMessagesByPerson, sendMessage, textChanged } from '../../actions/InboxActions';
import ImageOrLettersView from './ImageOrLettersView';
import SearchSidebarView from './SearchSidebarView';
import MessageListItemView from './MessageListItemView';
import MessageThreadItemView from './MessageThreadItemView';
import Textarea from 'react-textarea-autosize';
import pubSub from '../../PubSub';
import moment from 'moment';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';


function mapStateToProps(state, props) {
    const { inboxReducer, personsReducer, eventReducer, meReducer } = state;
    const otherPersonId = props.otherPersonId;
    const persons = personsReducer.persons || [];
    const personArr = persons.filter((person) => (otherPersonId == person.id));
    return {
        event: eventReducer.event,
        me: meReducer.me,
        messagesByPerson: inboxReducer.messagesByPerson[otherPersonId] || false,
        lastMessages: inboxReducer.lastMessages,
        person: personArr[0] || {},
        currentMessageText: inboxReducer.currentMessageText
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getLastMessages,
        getMessagesByPerson,
        sendMessage,
        textChanged
    }, dispatch);
}


class CommunityInbox extends Component {

    componentDidMount() {
        Utils.addClass(document.body, 'inbox-app');
        pubSub.publish('socketOn', 'badge', () => {
            this.getLastMessages();
        });
        this.getTextareaValue();
        this.getLastMessages();
    }

    componentWillUnmount() {
        Utils.removeClass(document.body, 'inbox-app');
    }

    componentDidUpdate(prevProps) {
        const el = ReactDOM.findDOMNode(this.refs.inboxMessageContainer);
        el.scrollTop = el.scrollHeight;
        if (this.props.otherPersonId && this.props.otherPersonId !== prevProps.otherPersonId) {
            this.getMessagesByPerson(this.props.otherPersonId, this.props.event.id);
        }
    }

    getLastMessages() {
        this.props.getLastMessages({
            eventId: this.props.event && this.props.event.id,
            otherPersonId: this.props.otherPersonId
        });
    }

    getMessagesByPerson(id, eventId) {
        this.props.getMessagesByPerson({
            targetId: id,
            eventId: eventId
        });
    }

    sendMessage(text) {
        this.props.textChanged(text.trim(), this.props.otherPersonId);
        this.props.sendMessage({
            targetId: this.props.otherPersonId,
            eventId: this.props.event.id,
            fullName: Utils.getFullName(this.props.person.firstName, this.props.person.lastName)
        });
    }

    getTextareaValue() {
        let value = '';
        const {messagesByPerson, currentMessageText={}, otherPersonId, person, me} = this.props;
        const hasMessages = messagesByPerson && messagesByPerson.length > 0;
        const idDirty = Object.keys(currentMessageText).includes(otherPersonId.toString());
        if (currentMessageText[otherPersonId]) {
            value = currentMessageText[otherPersonId];
        } else if (!hasMessages && messagesByPerson !== false && otherPersonId && !idDirty) {
            let firstName = person.firstName || '';
            value = `Hi ${firstName}, it is very nice to meet you. I'd be happy to connect. ${me.firstName}`;
        }
        return value;
    }

    getDay(time) {
        time = moment(time);
        let isCurrentDate = time.isSame(new Date(), 'day');
        if (isCurrentDate) {
            return 'Today';
        } else {
            return time.format('MMM D, YYYY');
        }
    }

    render() {
        let cx = classnames;
        const hasMessages = this.props.messagesByPerson && this.props.messagesByPerson.length > 0;
        let currentDay;
        let textareaValue = this.getTextareaValue();
        const isOverLimit = textareaValue?.length > 1000;

        return <div className="inbox-container">
            <div>
                <div className="inbox-wrapper container padding-horizontal-none">
                    <div className="inbox-message-container">
                        <div className={cx('message-thread-container', {'move': this.props.otherPersonId})}>
                            <div className="inbox-title-component color-1 text-left">INBOX</div>
                            <div className="inbox-search-component">
                                <Col xs={12} className="padding-bottom-small">
                                    <SearchSidebarView name="SEARCH CONVERSATION" placeHolder="Search"
                                        handleChange={this.handleChange}/>
                                </Col>
                                <Col xs={12} className="thread-container">
                                    {this.props.lastMessages.map((message) => <Link
                                        to={getInternalWebsiteBaseUrl(this.props.event, 'inbox/' + message['other-person-id'])}
                                        key={message.id}><MessageListItemView
                                            key={message.id} message={message}
                                            isSelected={this.props.otherPersonId === message['other-person-id']}
                                            meId={this.props.me.id}/></Link>)}
                                </Col>
                                <div className={cx('text-center hide-visible', {})}
                                    style={{visibility: (!this.props.otherPersonId && this.props.lastMessages.length === 0) ? 'visible' : 'hidden'}}>
                                    <div className="empty-state-no-person-container make-relative">
                                        <img className="empty-state-1-image" src="/images/community/empty_icon.png"
                                            alt=""/>
                                        <div className="empty-state-text padding-horizontal-small">
                                            <strong>Looks like there aren’t any messages!</strong>
                                            <br/>
                                            {'Click on someone’s profile from '}
                                            <br/>
                                            the <a href={getInternalWebsiteBaseUrl(this.props.event, 'community')}>community</a> to send a message
                                            <br/>
                                            {' and spark a conversation'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={cx('messages-container', {'move': this.props.otherPersonId})}>
                            <Col xs={12} className="inbox-message-component make-relative" ref="inboxMessageContainer">
                                <div className={cx('first-time-conversation text-center',
                                    {'hide': hasMessages || this.props.messagesByPerson === false || !this.props.otherPersonId})}>
                                    <div className="empty-state-first-message-container make-relative">
                                        <img className="empty-state-1-image" src="/images/community/empty_icon.png"
                                            alt=""/>
                                        <div className="empty-state-text"><strong>Time to be social! </strong>These
                                            private messages between you and
                                        <strong> {Utils.getFullName(this.props.person.firstName, this.props.person.lastName)}</strong><br/>
                                            allow you to make a valuable connection.<br/>
                                        <strong className="empty-state-small-text">Start a conversation
                                                with {Utils.getFullName(this.props.person.firstName, this.props.person.lastName)}
                                                &nbsp;by typing your first message below</strong>
                                        </div>
                                    </div>
                                </div>
                                <div className={cx('text-center',
                                    {'hide': this.props.otherPersonId || this.props.lastMessages.length === 0})}>
                                    <div className="empty-state-no-person-container make-relative">
                                        <img className="empty-state-1-image" src="/images/community/empty_icon.png"
                                            alt=""/>
                                        <div className="empty-state-text"><strong>Time to be social! </strong><br/>Click
                                            on a conversation to send a message
                                        </div>
                                    </div>
                                </div>
                                {this.props.messagesByPerson && this.props.messagesByPerson.map((message, index) => {
                                    const day = this.getDay(message.created);
                                    const showDay = (day !== currentDay);
                                    currentDay = day;
                                    return <div key={index}>
                                        {showDay &&
                                        <div className="text-center">
                                            <span className="messages-date">{day}</span>
                                        </div>
                                        }
                                        <MessageThreadItemView message={message}
                                            me={this.props.me}
                                            person={this.props.person} key={message.id}/>
                                    </div>;
                                })}
                            </Col>
                            <div className="person-content-container">
                                <div className="back-to-messages-thread">
                                    <Link to={getInternalWebsiteBaseUrl(this.props.event, 'inbox')}><i
                                        className="icon icon-up icon-inbox-back visible-xs"/></Link>
                                </div>
                                <div className="text-center person-link-container">
                                    <Link
                                        to={getInternalWebsiteBaseUrl(this.props.event, 'person/' + this.props.otherPersonId)}
                                        className="link-to-user-profile">
                                        <div className="inbox-message-image-container person-image">
                                            <ImageOrLettersView image={this.props.person.photoUrl}
                                                firstName={this.props.person.firstName}
                                                lastName={this.props.person.lastName}
                                                shape="round-corners"/>
                                        </div>
                                        <div className="person-name margin-left-small">
                                            <span>{Utils.getFullName(this.props.person.firstName, this.props.person.lastName)}</span>
                                        </div>
                                    </Link>
                                </div>
                            </div>
                            {this.props.otherPersonId && <div
                                className={cx('message-content-container', {'hide': !this.props.otherPersonId && this.props.lastMessages.length === 0})}>
                                <Textarea className="col-xs-10 inbox-textarea" minRows={2} maxRows={2}
                                    placeholder="Write message..."
                                    value={textareaValue || ''}
                                    onChange={(e) => this.props.textChanged(e.target.value, this.props.otherPersonId)}/>
                                <button className="btn btn-success send-text-button color-1-background col-xs-2"
                                    onClick={() => this.sendMessage(textareaValue)}
                                    disabled={!(textareaValue || '').trim() || isOverLimit}>
                                    SEND
                                </button>
                                {isOverLimit ? <div className='message-warning'>1,000 chars max limit reached</div> : null}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunityInbox);
